import React from 'react';
import { SkeletonBlock } from './SkeletonBlock';

interface SkeletonTextProps {
  lines?: number;
  lineHeight?: number;
  gap?: number;
  className?: string;
}

export const SkeletonText: React.FC<SkeletonTextProps> = ({
  lines = 3,
  lineHeight = 12,
  gap = 8,
  className = '',
}) => {
  return (
    <div className={`aa-skeleton-text ${className}`} aria-hidden="true">
      {Array.from({ length: lines }).map((_, index) => (
        <SkeletonBlock
          // Keep each line visually different so the skeleton feels natural.
          key={index}
          height={lineHeight}
          width={index === lines - 1 ? '72%' : '100%'}
          className="aa-skeleton-line"
          style={{ marginTop: index === 0 ? 0 : gap }}
        />
      ))}
    </div>
  );
};
